import {Col, Layout, Row, FloatButton, Image} from "antd";
import {useLocation, useSearchParams} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {useEffect, useRef, useState, useCallback} from 'react';
import { setTokenCookie, setEmbedTokenCookie, RootState, getSpecialists } from "../../../utils";
import { setEmbedData } from "../../../utils";
import { LANG_KEY } from "../../../utils";
import {Header} from "../Header";
import {Footer} from "../Footer";
import {Outlet} from "react-router-dom";
import {Color} from "../../../assets";
import { selectStore } from "../../../utils";
import { useSelector } from "react-redux";
import {Cookies} from "react-cookie";
import { COOKIE_KEY } from '../../../utils';
import {ArrowUpOutlined} from '@ant-design/icons';
import {useLang} from "../../../utils/context/lang";
import { fetchAuth } from "../../../utils";
import { useEmbeddedNavigate } from "../../../utils/context/embed";
import AskIcon from '../../../assets/images/pages/Main/ask-icon.svg'
import { AskButton } from "./styles";
import { ConsultationFormModal } from "../../popups/ConsulationPopup/ConsultationPopup";
import { MyButton } from "../..";

export const ProtectedLayout = () => {
  const location = useLocation();
  const contentRef = useRef<HTMLDivElement>(null);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const { profile: { embedData: embedDataState}} = useSelector(selectStore);
  const { profile: { userData: userDataState}} = useSelector(selectStore);
  const cookies = new Cookies()

  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [canSelectSpecialist, setCanSelectSpecialist] = useState(false);
  const { profile: {specialistsData: specialistsState}}: RootState = useSelector(selectStore); 
  const specialists = Array.isArray(specialistsState?.data)
  ? specialistsState.data
  : [];
  const [searchParams, setSearchParams] = useSearchParams();
  const [hovered, setHovered] = useState(false);

  const themeParam = searchParams.get('embed');
  const tokenParam = searchParams.get('etoken');
  const langParam = searchParams.get('lang');
  const {handleChangeLang, lang} = useLang()
  const embeddedNavigate = useEmbeddedNavigate();
  const urlParams = new URLSearchParams(window.location.search);

  const isEmbed = urlParams.get('embed'); 
  const eToken = urlParams.get('etoken'); 

  // let isEmbed = cookies.get(COOKIE_KEY.EMBED);
  let accessToken = cookies.get(COOKIE_KEY.ACCESS_TOKEN);

  const dispatch = useDispatch();

//   useEffect(() => {
//   if (tokenParam) {
//     setTokenCookie(tokenParam);
//   }
// }, [tokenParam]);

// useEffect(() => {
//   if (!token) return;

//   const data = userDataState?.data;
//   const isProfileLoaded = userDataState?.success;

//   if (!isProfileLoaded || !data) return;

//   if (data.region_id === null || data.region_id === undefined) {
//     embeddedNavigate('/register/confirm');
//   }
// }, [token, userDataState?.data?.region_id]);

const showModal = () => {
    setIsModalVisible(true);
    setCanSelectSpecialist(true);
  };

  const handleOk = () => setIsModalVisible(false);

  const handleCancel = () => {
    setIsModalVisible(false);
    setCanSelectSpecialist(false);
  };

useEffect(() => {
  dispatch(getSpecialists({ type: 1 }));
}, [dispatch]);

useEffect(() => {
  const embed = searchParams.get('embed');
  if (embed) {
    dispatch(setEmbedData(embed));
  }
}, []);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

    useEffect(() => {
      if (contentRef.current) {
        contentRef.current.scrollTop = 0;
      }
    }, [location.pathname]);

   useEffect(() => {
    const handleScroll = () => {
      if (!contentRef.current) return;

      const scrollTop = contentRef.current.scrollTop;
      const screenHeight = window.innerHeight;
      setShowScrollTop(scrollTop > screenHeight * 1.5);
    };

    const ref = contentRef.current;
    if (ref) {
      ref.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (ref) {
        ref.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const scrollToTop = () => {
    if (contentRef.current) {
      contentRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleLogin = async () => {
  try {
    const currentAccessToken = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
    if (!currentAccessToken && tokenParam) {
      await dispatch(fetchAuth({ token: tokenParam }));
    }
  } catch (error) {}
};

  useEffect(() => {
    handleLogin();
  }, []);

  const handleChangeLangSelect = useCallback((value: any) => {
      handleChangeLang(value)
    }, [])
    
  

   const hasSyncedLangRef = useRef(false);

    useEffect(() => {
      if (
        !hasSyncedLangRef.current &&
        langParam &&
        langParam !== lang &&
        [LANG_KEY.KZ, LANG_KEY.RU, LANG_KEY.AR, LANG_KEY.EN].includes(langParam)
      ) {
        hasSyncedLangRef.current = true;
        handleChangeLang(langParam);
      }
    }, [langParam, lang]);

  return (
    <>
    {!embedDataState?.data && <Header />}
      <Layout.Content
        ref={contentRef}
        style={{
          overflowY: 'scroll',
          overflowX: 'hidden',
          scrollBehavior: 'smooth',
          backgroundColor: '#FCF8F1',
          padding: '24px 0',
          paddingBottom: '0',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Outlet context={{ contentRef }}/>
        {!embedDataState?.data && 
          <Footer/>
        }
        {location.pathname === '/diagnostics-marathon' && (
          <div style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            background: '#FF9500',
            borderTop: '1px solid #E5E9F2',
            padding: '16px 24px',
            display: 'flex',
            zIndex: 100,
            justifyContent: 'center',
            boxShadow: '0 -4px 16px rgba(0,0,0,0.06)',
          }}>
            <MyButton
              type="default"
              onClick={() => embeddedNavigate('/speech-marathon')}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              style={{
                color: hovered ? '#fcb047' : '#FF9500',
                border: `1px solid ${hovered ? '#fcb047' : '#FF9500'}`,
                background: '#fff',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                transition: 'all 0.2s ease',
              }}
            >
              Нажмите чтобы начать марафон
            </MyButton>
          </div>
        )}
        <AskButton
          justify="center"
          align="middle"
           onClick={() =>
                          (isEmbed && eToken)
                            ? showModal()
                            : (
                                token
                                  ? showModal()
                                  : embeddedNavigate('/auth')
                              )
                        }
        >
          <Image
            src={AskIcon}
            preview={false}
            width={50}
            height={50}
          />
        </AskButton>
          
         {showScrollTop && (
          <FloatButton
            onClick={scrollToTop}
            icon={<ArrowUpOutlined />}
            style={{
              position: 'fixed',
              bottom: 30,
              right: 20,
              zIndex: 1000,
            }}
            type="primary"
          />
        )}
      <ConsultationFormModal visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} specialists={specialists} canSelectSpecialist={canSelectSpecialist}/>
        
      </Layout.Content>
    </>
  )
}